import styled from "styled-components";

export const StyledHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const Palg1Wrap = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
`;

export const Header = styled.div`
  margin-bottom: 10px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 25px;
  line-height: 28px;
  /* identical to box height, or 112% */
  display: flex;
  align-items: center;

  /* Текст/#333333 текст|кнопки */
  color: #333333;
  @media (max-width: 768px) {
    font-size: 20px;
  }
`;
export const WrapSelect = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0px;
`;

export const DiffWrap = styled.div`
  position: absolute;
  top: 14%;
  left: 0px;
  z-index: 10;
`;
export const CharWrap = styled.div`
  height: 70%;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
`;
